var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.167969 16.0001C0.167969 7.25557 7.25679 0.166748 16.0013 0.166748C20.2006 0.166748 24.2278 1.8349 27.1972 4.80422C30.1665 7.77355 31.8346 11.8008 31.8346 16.0001C31.8346 24.7446 24.7458 31.8334 16.0013 31.8334C7.25679 31.8334 0.167969 24.7446 0.167969 16.0001ZM21.1336 19.4992C21.1336 19.2892 21.0467 19.0887 20.8937 18.945L17.9645 16L20.8937 13.055C21.0467 12.9113 21.1336 12.7108 21.1336 12.5008C21.1336 12.2909 21.0467 12.0903 20.8937 11.9467L20.0545 11.1075C19.9108 10.9544 19.7103 10.8676 19.5003 10.8676C19.2904 10.8676 19.0898 10.9544 18.9462 11.1075L16.0012 14.0367L13.0562 11.1075C12.9125 10.9544 12.7119 10.8676 12.502 10.8676C12.2921 10.8676 12.0915 10.9544 11.9478 11.1075L11.1087 11.9467C10.9556 12.0903 10.8688 12.2909 10.8688 12.5008C10.8688 12.7108 10.9556 12.9113 11.1087 13.055L14.0378 16L11.1087 18.945C10.9556 19.0887 10.8688 19.2892 10.8688 19.4992C10.8688 19.7091 10.9556 19.9097 11.1087 20.0533L11.9478 20.8925C12.0915 21.0456 12.2921 21.1324 12.502 21.1324C12.7119 21.1324 12.9125 21.0456 13.0562 20.8925L16.0012 17.9633L18.9462 20.8925C19.0898 21.0456 19.2904 21.1324 19.5003 21.1324C19.7103 21.1324 19.9108 21.0456 20.0545 20.8925L20.8937 20.0533C21.0467 19.9097 21.1336 19.7091 21.1336 19.4992Z",
    fill: "#D6001A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedClose);
export default __webpack_public_path__ + "static/media/red-close.121dda9ed3fa98cd3d76629ec123a510.svg";
export { ForwardRef as ReactComponent };